import actions from './actions';

const {
  GET_LOAD,
  GET_SUCCESS,
  GET_ERROR,
  ADD_MONITOR_BEGIN,
  ADD_MONITOR_SUCCESS,
  ADD_MONITOR_ERROR,
  GET_MONITOR_DETAIL_LOAD,
  GET_MONITOR_DETAIL_SUCCESS,
  GET_MONITOR_DETAIL_ERROR,
} = actions;

const initialState = {
  data: [],
  monitorDetail: [],
  loading: false,
  error: null,
};

const monitorsReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case GET_LOAD:
      return { ...state, loading: true };

    case GET_SUCCESS:
      return { ...state, data, error: false, loading: false };

    case GET_ERROR:
      return { ...state, error: err, loading: false };

    case ADD_MONITOR_BEGIN:
      return { ...state, loading: true };

    case ADD_MONITOR_SUCCESS:
      return { ...state, data, loading: true, error: false };

    case ADD_MONITOR_ERROR:
      return { ...state, error: err, loading: false };

    case GET_MONITOR_DETAIL_LOAD:
      return { ...state, loading: true };

    case GET_MONITOR_DETAIL_SUCCESS:
      return { ...state, monitorDetail: data, error: false, loading: false };

    case GET_MONITOR_DETAIL_ERROR:
      return { ...state, error: err, loading: false };

    default:
      return state;
  }
};

export { monitorsReducer };
